// @flow
import { connect } from "react-redux";
import { finishProgress, startProgress } from "../actions/ProgressIndicator";
import { handleError } from "../actions/Error";

import type {
  StartProgressAction,
  FinishProgressAction,
  ThunkAction,
} from "../types";
import type FetchException from "../../exceptions/FetchException";
import type { ComponentType } from "react";

type DispatchProps = {
  onStartProgress: () => StartProgressAction,
  onFinishProgress: () => FinishProgressAction,
  onError: (error: Error | FetchException) => ThunkAction<>,
};

const mapDispatchToProps: DispatchProps = {
  onStartProgress: startProgress,
  onFinishProgress: finishProgress,
  onError: handleError,
};

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useProgressIndicator' instead
 */
export const connectProgress: ComponentType<any> = connect<
  DispatchProps,
  {},
  _,
  _,
  _,
  _,
>(null, mapDispatchToProps);
